module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ConfigOverview"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.lang.W00000))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00001))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00002))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00003))]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.configurations), function(config) {
    return _c('div', {
      key: config.ConfigurationGuid,
      staticClass: "wizard-table-row"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(config.Title))]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(config.Status))]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(config.LastUpdate)))]), _vm._v(" "), _c('div', {
      staticClass: "table-cell"
    }, [_c('router-link', {
      staticClass: "resume-btn",
      attrs: {
        "to": ("/config/" + (config.ConfigurationGuid))
      }
    }, [(config.Status == 'finished') ? _c('span', [_vm._v(_vm._s(_vm.lang.W00089))]) : _c('span', [_vm._v(_vm._s(_vm.lang.W00004))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "table-cell delete-config-btn-td"
    }, [_c('button', {
      staticClass: "delete-config-btn",
      attrs: {
        "disabled": config.Status == 'finished'
      },
      on: {
        "click": function($event) {
          return _vm.openConfirmationDialog(config.ConfigurationGuid)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("delete")])])])])
  }), 0)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "id": "new-config-btn",
      "to": "/config/new"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("add")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.W00008))])]), _vm._v(" "), _c('ConfirmationDialog', {
    attrs: {
      "dialogId": "deleteConfigConfirmationDialog",
      "confirmationTitle": "Do you want really to delete the configuration?",
      "yesButtonText": "Delete",
      "noButtonText": "Cancel",
      "showDialog": _vm.showDeleteConfigConfirmationDialog
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e82578","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/ConfigOverview.vue
// module id = 1666
// module chunks = 1